export function assertsPropertiesAreDefined<Type extends object, Keys extends keyof Type>(obj: Type, keys: Keys[]): asserts obj is Type & Required<Pick<Type, Keys>> {
  const notDefined = keys.find(k => !isDefined(obj[k]))
  if (notDefined) {
    throw new Error(`missing required property ${String(notDefined)}`)
  }
}
